import { Instance } from 'mobx-state-tree';
import { ShopifyAvailableFieldDtoModelBase } from './ShopifyAvailableFieldDtoModel.base';

/* The TypeScript type of an instance of ShopifyAvailableFieldDtoModel */
export interface ShopifyAvailableFieldDtoModelType
  extends Instance<typeof ShopifyAvailableFieldDtoModel.Type> {}

/* A graphql query fragment builders for ShopifyAvailableFieldDtoModel */
export {
  selectFromShopifyAvailableFieldDto,
  shopifyAvailableFieldDtoModelPrimitives,
  ShopifyAvailableFieldDtoModelSelector,
} from './ShopifyAvailableFieldDtoModel.base';

/**
 * ShopifyAvailableFieldDtoModel
 */
export const ShopifyAvailableFieldDtoModel = ShopifyAvailableFieldDtoModelBase;
